var map = {
	"./OneColumn": [
		2996,
		793
	],
	"./OneColumn.jsx": [
		2996,
		793
	],
	"./TwoColumn": [
		5679,
		793
	],
	"./TwoColumn.jsx": [
		5679,
		793
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3819;
module.exports = webpackAsyncContext;